export default "__VITE_ASSET__D1j22SDH__"